import { render, staticRenderFns } from "./ForgotPasswordView.vue?vue&type=template&id=b4943426"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInputComponent: require('/home/node/app/components/ui/inputComponent.vue').default,UiButtonComponent: require('/home/node/app/components/ui/buttonComponent.vue').default,ControllerForgotPassword: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/user/ControllerForgotPassword.js').default,UiIconsEyeClosed: require('/home/node/app/components/ui/icons/eyeClosed.vue').default,UiIconsEyeOpen: require('/home/node/app/components/ui/icons/eyeOpen.vue').default,ControllerResetPassword: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/user/ControllerResetPassword.js').default})
